import React from 'react';
import type {BoxProps} from '@mui/material/Box';
import Box from '@mui/material/Box';
import {useTheme} from '@mui/material/styles';
import type {SxProps, Theme} from '@mui/material';

export interface CCOStageTextBoxProps extends BoxProps {
    blackBg?: boolean;
}

const getBaseSx = (theme: Theme, blackBg?: boolean): SxProps<Theme> => ({
    position: 'relative',
    color: theme.palette.primary.contrastText,
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 0,
    marginBottom: 0,
    marginTop: '-1px',

    width: 'auto',
    backgroundColor: blackBg ? '#000' : theme.palette.primary.main,
    paddingLeft: '24px',
    paddingTop: '32px',
    paddingBottom: '32px',

    [theme.breakpoints.down('md')]: {
        paddingRight: '8px',
    },
    [theme.breakpoints.up('sm')]: {
        paddingLeft: '73px',
    },
    [theme.breakpoints.up('md')]: {
        width: '304px',
        height: '240px',
        backgroundColor: 'transparent',
        paddingLeft: '124px',
        paddingTop: 0,
        paddingBottom: 0,
    },
    [theme.breakpoints.up('lg')]: {
        width: '368px',
        height: '280px',
    },
    [theme.breakpoints.up('xl')]: {
        width: '496px',
        height: '400px',
        paddingLeft: '260px',
    },
    [theme.breakpoints.up(1920)]: {
        // Match the centered navigation while preserving the text box's content width.
        marginLeft: `calc((100% - ${theme.breakpoints.values.xl}px) / 2 - 260px)`,
    },
});

export const CCOStageTextBox: React.FC<CCOStageTextBoxProps> = ({
                                                                    blackBg,
                                                                    sx,
                                                                    ...rest
                                                                }) => {
    const theme = useTheme();
    const baseSx = getBaseSx(theme, blackBg);

    const mergedSx: SxProps<Theme> = {
        ...(baseSx as any),
        ...(sx as any),
    };

    return <Box sx={mergedSx} {...rest} />;
};
